// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vehicle-specials-bannerwrapper[data-v-79be48f2] {
  background: #f5f5f5;
  box-shadow: 0 3px 6px 0 #00000029;
}
._website_gemini .vehicle-specials-bannerwrapper[data-v-79be48f2] {
  background: #fff !important;
  border: 2px solid #f5f5f5;
  box-shadow: none !important;
}
.vehicle-specials-vehiclename[data-v-79be48f2] {
  color: #102b4e;
  font-size: 24px;
  line-height: 1.42;
  letter-spacing: 0.72px;
}
.vehicle-specials-viewdetails[data-v-79be48f2] {
  background: transparent;
  border: 0;
  padding: 6px !important;
  text-align: left;
  color: #102b4e !important;
  font-size: 18px;
  letter-spacing: 0.18px;
}
.vehicle-description[data-v-79be48f2]::first-letter {
  text-transform: uppercase !important;
}
.vehicle-specials-banner.rounded-box[data-v-79be48f2] {
  padding: 30px 0;
}
.color-linclon[data-v-79be48f2] {
  color: #102b4e;
}
.price[data-v-79be48f2] {
  padding-top: 24px;
  text-transform: uppercase;
}
.f-16-t-u[data-v-79be48f2] {
  padding: 17px 0 25px;
}
.f-16[data-v-79be48f2] {
  font-size: 16px !important;
}
.vehicle-specials-box.vehicle-specials-slider-box.g-page-section .slick-slide[data-v-79be48f2] {
  margin: 12px;
}
.vehicle-specials-banner[data-v-79be48f2] {
  height: auto !important;
}
.slick-slide .vehicle-specials[data-v-79be48f2] {
  background: #ffffff !important;
}
.vehicle-title-wrapper[data-v-79be48f2] {
  font-size: 35px;
  text-transform: uppercase;
  color: #4d4d4d;
  margin-bottom: 60px !important;
  font-weight: normal;
  padding-top: 1.5rem !important;
  margin-top: 0 !important;
}
@media (max-width: 700px) {
.vehicle-title-wrapper[data-v-79be48f2] {
    font-size: 25px;
}
.vehicle-specials-box[data-v-79be48f2] {
    margin-bottom: 42px;
}
.f-16-t-u[data-v-79be48f2] {
    padding: 12px 0px;
}
.vehicle-specials-banner.rounded-box[data-v-79be48f2] {
    padding: 0;
}
.vehicle-specials-banner.rounded-box .container[data-v-79be48f2] {
    padding: 0;
}
.bt-1[data-v-79be48f2] {
    padding: 10px 0px;
    border-top: 1px solid #e5e5e5;
    text-align: center;
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/RotaionalSpecialBanner/LincolnNewRotationalBanners.vue","webpack://./LincolnNewRotationalBanners.vue"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,iCAAA;ACAF;ADEA;EACE,2BAAA;EACA,yBAAA;EACA,2BAAA;ACAF;ADEA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;ACAF;ADEA;EACE,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;ACAF;ADGA;EACE,oCAAA;ACDF;ADIA;EACE,eAAA;ACFF;ADIA;EACE,cAAA;ACFF;ADIA;EACE,iBAAA;EACA,yBAAA;ACFF;ADIA;EACE,oBAAA;ACFF;ADIA;EACE,0BAAA;ACFF;ADIA;EACE,YAAA;ACFF;ADIA;EACE,uBAAA;ACFF;ADIA;EACE,8BAAA;ACFF;ADKA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;ACHF;ADOA;AACE;IACE,eAAA;ACLF;ADOA;IACE,mBAAA;ACLF;ADOA;IACE,iBAAA;ACLF;ADOA;IACE,UAAA;ACLF;ADIA;IAGI,UAAA;ACJJ;ADOA;IACE,iBAAA;IACA,6BAAA;IACA,kBAAA;ACLF;AACF","sourcesContent":["\n.vehicle-specials-bannerwrapper {\n  background: #f5f5f5;\n  box-shadow: 0 3px 6px 0 #00000029;\n}\n._website_gemini .vehicle-specials-bannerwrapper {\n  background: #fff !important;\n  border: 2px solid #f5f5f5;\n  box-shadow: none !important;\n}\n.vehicle-specials-vehiclename {\n  color: #102b4e;\n  font-size: 24px;\n  line-height: 1.42;\n  letter-spacing: 0.72px;\n}\n.vehicle-specials-viewdetails {\n  background: transparent;\n  border: 0;\n  padding: 6px !important;\n  text-align: left;\n  color: #102b4e !important;\n  font-size: 18px;\n  letter-spacing: 0.18px;\n}\n\n.vehicle-description::first-letter {\n  text-transform: uppercase !important;\n}\n\n.vehicle-specials-banner.rounded-box {\n  padding: 30px 0;\n}\n.color-linclon {\n  color: #102b4e;\n}\n.price {\n  padding-top: 24px;\n  text-transform: uppercase;\n}\n.f-16-t-u {\n  padding: 17px 0 25px;\n}\n.f-16 {\n  font-size: 16px !important;\n}\n.vehicle-specials-box.vehicle-specials-slider-box.g-page-section .slick-slide {\n  margin: 12px;\n}\n.vehicle-specials-banner {\n  height: auto !important;\n}\n.slick-slide .vehicle-specials {\n  background: #ffffff !important;\n}\n\n.vehicle-title-wrapper {\n  font-size: 35px;\n  text-transform: uppercase;\n  color: #4d4d4d;\n  margin-bottom: 60px !important;\n  font-weight: normal;\n  padding-top: 1.5rem !important;\n  margin-top: 0 !important;\n}\n\n\n@media (max-width: 700px) {\n  .vehicle-title-wrapper {\n    font-size: 25px;\n  }\n  .vehicle-specials-box {\n    margin-bottom: 42px;\n  }\n  .f-16-t-u {\n    padding: 12px 0px;\n  }\n  .vehicle-specials-banner.rounded-box {\n    padding: 0;\n    .container {\n      padding: 0;\n    }\n  }\n  .bt-1 {\n    padding: 10px 0px;\n    border-top: 1px solid #e5e5e5;\n    text-align: center;\n  }\n}\n",".vehicle-specials-bannerwrapper {\n  background: #f5f5f5;\n  box-shadow: 0 3px 6px 0 #00000029;\n}\n._website_gemini .vehicle-specials-bannerwrapper {\n  background: #fff !important;\n  border: 2px solid #f5f5f5;\n  box-shadow: none !important;\n}\n.vehicle-specials-vehiclename {\n  color: #102b4e;\n  font-size: 24px;\n  line-height: 1.42;\n  letter-spacing: 0.72px;\n}\n.vehicle-specials-viewdetails {\n  background: transparent;\n  border: 0;\n  padding: 6px !important;\n  text-align: left;\n  color: #102b4e !important;\n  font-size: 18px;\n  letter-spacing: 0.18px;\n}\n.vehicle-description::first-letter {\n  text-transform: uppercase !important;\n}\n.vehicle-specials-banner.rounded-box {\n  padding: 30px 0;\n}\n.color-linclon {\n  color: #102b4e;\n}\n.price {\n  padding-top: 24px;\n  text-transform: uppercase;\n}\n.f-16-t-u {\n  padding: 17px 0 25px;\n}\n.f-16 {\n  font-size: 16px !important;\n}\n.vehicle-specials-box.vehicle-specials-slider-box.g-page-section .slick-slide {\n  margin: 12px;\n}\n.vehicle-specials-banner {\n  height: auto !important;\n}\n.slick-slide .vehicle-specials {\n  background: #ffffff !important;\n}\n.vehicle-title-wrapper {\n  font-size: 35px;\n  text-transform: uppercase;\n  color: #4d4d4d;\n  margin-bottom: 60px !important;\n  font-weight: normal;\n  padding-top: 1.5rem !important;\n  margin-top: 0 !important;\n}\n@media (max-width: 700px) {\n  .vehicle-title-wrapper {\n    font-size: 25px;\n  }\n  .vehicle-specials-box {\n    margin-bottom: 42px;\n  }\n  .f-16-t-u {\n    padding: 12px 0px;\n  }\n  .vehicle-specials-banner.rounded-box {\n    padding: 0;\n  }\n  .vehicle-specials-banner.rounded-box .container {\n    padding: 0;\n  }\n  .bt-1 {\n    padding: 10px 0px;\n    border-top: 1px solid #e5e5e5;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
